import { createAsyncActionType } from '.';

export const SET_DOMAIN = '@@domain/SET_DOMAIN';

export const GET_DOMAIN = createAsyncActionType('domain', 'GET_DOMAIN');
